<script lang="ts">
  import { onMount } from "svelte";
  import { setHeadTitle } from "../../app/store/store-ui";
  import AuthLayout from "../layout/AuthLayout.svelte";
  import TwoFactorAuthentication from "../../components/auth/two-factor-authentication/TwoFactorAuthentication.svelte";

  onMount(() => {
    setHeadTitle("Authentication");
    return () => setHeadTitle("");
  })
</script>

<AuthLayout>
  <TwoFactorAuthentication />
</AuthLayout>
